// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   IconButton,
//   Alert,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { Flag } from '@mui/icons-material';
// import apiService from '../services/apiService';

// const RatingsPage = () => {
//   const [ratings, setRatings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');

//   const fetchRatings = useCallback(async () => {
//     try {
//       setLoading(true);
//       const response = await apiService.getRatings();

//       if (response.success) {
//         setRatings(response.data);
//       } else {
//         setError(response.message || 'Failed to load ratings');
//         loadMockData();
//       }
//     } catch (err) {
//       console.error('Ratings error:', err);
//       setError('Failed to load ratings');
//       loadMockData();
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchRatings();
//   }, [fetchRatings]);

//   const loadMockData = () => {
//     setRatings([
//       {
//         id: '1',
//         rideId: 'RIDE001',
//         reviewerName: 'Priya Sharma',
//         targetName: 'Rajesh Kumar',
//         type: 'driver',
//         rating: 5,
//         review: 'Excellent service, very professional driver!',
//         createdAt: '2025-01-08 11:00 AM',
//       },
//       {
//         id: '2',
//         rideId: 'RIDE002',
//         reviewerName: 'Suresh Reddy',
//         targetName: 'Amit Kumar',
//         type: 'passenger',
//         rating: 4,
//         review: 'Good passenger, polite and on time.',
//         createdAt: '2025-01-08 12:00 PM',
//       },
//       {
//         id: '3',
//         rideId: 'RIDE003',
//         reviewerName: 'Sneha Reddy',
//         targetName: 'Vikram Singh',
//         type: 'driver',
//         rating: 2,
//         review: 'Driver was rude and drove rashly.',
//         createdAt: '2025-01-08 01:00 PM',
//       },
//     ]);
//   };

//   const handleFlag = async (id) => {
//     if (!window.confirm('Flag this rating for review?')) {
//       return;
//     }

//     try {
//       const response = await apiService.flagRating(id, 'Inappropriate content');

//       if (response.success) {
//         alert('Rating flagged successfully');
//         fetchRatings();
//       } else {
//         alert(response.message || 'Failed to flag rating');
//       }
//     } catch (err) {
//       alert('Failed to flag rating');
//     }
//   };

//   const getRatingStars = (rating) => {
//     return '⭐'.repeat(rating) + '☆'.repeat(5 - rating);
//   };

//   const getRatingColor = (rating) => {
//     if (rating >= 4) return 'success';
//     if (rating >= 3) return 'warning';
//     return 'error';
//   };

//   const columns = [
//     {
//       field: 'crn',
//       headerName: 'CRN',
//       width: 180,
//       renderCell: (params) => (
//         <Typography variant="body2" fontFamily="monospace" fontWeight={600}>
//           {params.row.crn || params.row.rideId?.substring(0, 8) + '...'}
//         </Typography>
//       ),
//     },
//     {
//       field: 'reviewerName',
//       headerName: 'Rated By',
//       width: 150,
//       renderCell: (params) => (
//         <Typography variant="body2">
//           {params.row.reviewerName || params.row.raterName || '-'}
//         </Typography>
//       ),
//     },
//     {
//       field: 'targetName',
//       headerName: 'Rated To',
//       width: 150,
//       renderCell: (params) => (
//         <Typography variant="body2">
//           {params.row.targetName || params.row.ratedName || '-'}
//         </Typography>
//       ),
//     },
//     {
//       field: 'type',
//       headerName: 'Type',
//       width: 120,
//       renderCell: (params) => (
//         <Chip
//           label={params.row.type || params.row.ratingType || '-'}
//           size="small"
//           color={params.row.type === 'driver' ? 'primary' : 'secondary'}
//         />
//       ),
//     },
//     {
//       field: 'rating',
//       headerName: 'Rating',
//       width: 150,
//       renderCell: (params) => (
//         <Box>
//           <Chip
//             label={params.row.rating}
//             color={getRatingColor(params.row.rating)}
//             size="small"
//             sx={{ mr: 1 }}
//           />
//           <Typography variant="caption">{getRatingStars(params.row.rating)}</Typography>
//         </Box>
//       ),
//     },
//     {
//       field: 'review',
//       headerName: 'Review',
//       width: 300,
//       renderCell: (params) => (
//         <Typography variant="body2" noWrap>
//           {params.row.review || params.row.comment || '-'}
//         </Typography>
//       ),
//     },
//     {
//       field: 'createdAt',
//       headerName: 'Date',
//       width: 160,
//     },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 100,
//       sortable: false,
//       renderCell: (params) => (
//         <IconButton size="small" color="error" onClick={() => handleFlag(params.row.id)}>
//           <Flag fontSize="small" />
//         </IconButton>
//       ),
//     },
//   ];

//   return (
//     <Box>
//       <Box sx={{ mb: 3 }}>
//         <Typography variant="h4" fontWeight="bold" gutterBottom>
//           Ratings & Reviews
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           View and manage passenger and driver ratings
//         </Typography>
//       </Box>

//       {error && (
//         <Alert severity="warning" sx={{ mb: 3 }}>
//           {error} - Showing demo data
//         </Alert>
//       )}

//       <Card>
//         <CardContent>
//           <DataGrid
//             rows={ratings}
//             columns={columns}
//             pageSize={10}
//             rowsPerPageOptions={[10, 25, 50]}
//             disableSelectionOnClick
//             autoHeight
//             loading={loading}
//             sx={{
//               '& .MuiDataGrid-cell:focus': {
//                 outline: 'none',
//               },
//             }}
//           />
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default RatingsPage;


import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  IconButton,
  Alert,
  Grid,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Stack,
  Paper,
  Avatar,
  LinearProgress,
  Tooltip,
  Button,
  InputAdornment,
  CircularProgress,
  Snackbar,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import {
  Flag,
  Search,
  Clear,
  TrendingUp,
  TrendingDown,
  Person,
  DirectionsCar,
  RateReview,
  FilterList,
  Download,
  Refresh,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import apiService from '../services/apiService';

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
  },
}));

const RatingsPage = () => {
  const [ratings, setRatings] = useState([]);
  const [filteredRatings, setFilteredRatings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [driverStats, setDriverStats] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  
  const [filters, setFilters] = useState({
    search: '',
    crn: '',
    ratedBy: '',
    ratedTo: '',
    type: '',
    rating: '',
    review: '',
  });

  // Transform API response to consistent format
  const transformRatingData = (apiData) => {
    // Handle both array and object responses
    const dataArray = Array.isArray(apiData) ? apiData : Object.values(apiData || {});
    
    return dataArray.map(item => ({
      id: item.id || item._id,
      rideId: item.rideId,
      crn: item.crn || 'N/A',
      type: item.type || 'driver',
      rating: item.rating || 0,
      review: item.review || item.comment || '',
      feedbackTags: item.feedbackTags || [],
      reviewerName: item.reviewerName || item.raterName || 'Anonymous',
      reviewerPhone: item.reviewerPhone || '',
      targetName: item.targetName || item.ratedName || 'Unknown',
      targetPhone: item.targetPhone || '',
      targetPhoto: item.targetPhoto || '',
      createdAt: item.createdAt || new Date().toISOString(),
      flagged: item.flagged || false,
    }));
  };

  // Fetch ratings from backend only
  const fetchRatings = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      
      const response = await apiService.getRatings();
      
      if (response && response.success !== false) {
        // Transform the data to consistent format
        const transformedData = transformRatingData(response.data || response);
        setRatings(transformedData);
        setFilteredRatings(transformedData);
        
        // Auto-select first driver if available
        if (transformedData.length > 0) {
          const firstDriver = transformedData[0].targetName;
          setSelectedDriver(firstDriver);
          calculateDriverStats(firstDriver, transformedData);
        }
      } else {
        throw new Error(response.message || 'Failed to load ratings');
      }
    } catch (err) {
      console.error('Ratings fetch error:', err);
      setError(err.message || 'Failed to load ratings from server');
      setRatings([]);
      setFilteredRatings([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRatings();
  }, [fetchRatings]);

  // Calculate driver statistics
  const calculateDriverStats = (driverName, data = ratings) => {
    const driverRatings = data.filter(r => r.targetName === driverName);
    
    if (driverRatings.length === 0) {
      setDriverStats(null);
      return;
    }

    const totalRatings = driverRatings.length;
    const avgRating = driverRatings.reduce((sum, r) => sum + r.rating, 0) / totalRatings;
    
    const ratingDistribution = {
      5: driverRatings.filter(r => r.rating === 5).length,
      4: driverRatings.filter(r => r.rating === 4).length,
      3: driverRatings.filter(r => r.rating === 3).length,
      2: driverRatings.filter(r => r.rating === 2).length,
      1: driverRatings.filter(r => r.rating === 1).length,
    };

    const ratingPercentages = {};
    Object.keys(ratingDistribution).forEach(key => {
      ratingPercentages[key] = (ratingDistribution[key] / totalRatings) * 100;
    });

    const recentRatings = [...driverRatings]
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 5);

    // Calculate trend
    const sortedByDate = [...driverRatings].sort((a, b) => 
      new Date(a.createdAt) - new Date(b.createdAt)
    );
    const midPoint = Math.floor(sortedByDate.length / 2);
    const recent = sortedByDate.slice(midPoint);
    const older = sortedByDate.slice(0, midPoint);
    const recentAvg = recent.length > 0 ? recent.reduce((s, r) => s + r.rating, 0) / recent.length : 0;
    const olderAvg = older.length > 0 ? older.reduce((s, r) => s + r.rating, 0) / older.length : 0;
    const trend = recentAvg - olderAvg;

    setDriverStats({
      driverName,
      totalRatings,
      avgRating,
      ratingDistribution,
      ratingPercentages,
      recentRatings,
      trend,
      recentAvg,
      olderAvg,
    });
  };

  const handleDriverSelect = (driverName) => {
    setSelectedDriver(driverName);
    if (driverName) {
      calculateDriverStats(driverName);
      const driverRatings = ratings.filter(r => r.targetName === driverName);
      setFilteredRatings(driverRatings);
    } else {
      setFilteredRatings(ratings);
      setDriverStats(null);
    }
  };

  // Apply filters
  const applyFilters = useMemo(() => {
    return () => {
      let filtered = [...ratings];

      if (filters.search) {
        const searchLower = filters.search.toLowerCase();
        filtered = filtered.filter(r => 
          r.crn?.toLowerCase().includes(searchLower) ||
          r.reviewerName?.toLowerCase().includes(searchLower) ||
          r.targetName?.toLowerCase().includes(searchLower) ||
          r.review?.toLowerCase().includes(searchLower) ||
          r.type?.toLowerCase().includes(searchLower)
        );
      }

      if (filters.crn) {
        filtered = filtered.filter(r => 
          r.crn?.toLowerCase().includes(filters.crn.toLowerCase())
        );
      }

      if (filters.ratedBy) {
        filtered = filtered.filter(r => 
          r.reviewerName?.toLowerCase().includes(filters.ratedBy.toLowerCase())
        );
      }

      if (filters.ratedTo) {
        filtered = filtered.filter(r => 
          r.targetName?.toLowerCase().includes(filters.ratedTo.toLowerCase())
        );
      }

      if (filters.type) {
        filtered = filtered.filter(r => r.type === filters.type);
      }

      if (filters.rating) {
        filtered = filtered.filter(r => r.rating === parseInt(filters.rating));
      }

      if (filters.review) {
        const reviewLower = filters.review.toLowerCase();
        filtered = filtered.filter(r => 
          r.review?.toLowerCase().includes(reviewLower)
        );
      }

      setFilteredRatings(filtered);
    };
  }, [ratings, filters]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  const clearFilters = () => {
    setFilters({
      search: '',
      crn: '',
      ratedBy: '',
      ratedTo: '',
      type: '',
      rating: '',
      review: '',
    });
    if (selectedDriver) {
      const driverRatings = ratings.filter(r => r.targetName === selectedDriver);
      setFilteredRatings(driverRatings);
    } else {
      setFilteredRatings(ratings);
    }
  };

  const handleFlag = async (id) => {
    if (!window.confirm('Flag this rating for review?')) {
      return;
    }

    try {
      setLoading(true);
      const response = await apiService.flagRating(id, 'Inappropriate content');

      if (response.success) {
        setSnackbar({
          open: true,
          message: 'Rating flagged successfully',
          severity: 'success',
        });
        fetchRatings(); // Refresh data
      } else {
        throw new Error(response.message || 'Failed to flag rating');
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || 'Failed to flag rating',
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const getRatingStars = (rating) => {
    return '⭐'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  const getRatingColor = (rating) => {
    if (rating >= 4) return 'success';
    if (rating >= 3) return 'warning';
    return 'error';
  };

  const uniqueDrivers = useMemo(() => {
    const drivers = new Set(ratings.map(r => r.targetName));
    return Array.from(drivers).filter(Boolean);
  }, [ratings]);

  const columns = [
    {
      field: 'crn',
      headerName: 'CRN',
      width: 200,
      renderCell: (params) => (
        <Tooltip title={params.row.crn}>
          <Typography variant="body2" fontFamily="monospace" fontWeight={600}>
            {params.row.crn}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'reviewerName',
      headerName: 'Rated By',
      width: 170,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2" fontWeight={500}>
            {params.row.reviewerName}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {params.row.reviewerPhone}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'targetName',
      headerName: 'Rated To',
      width: 170,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar 
            src={params.row.targetPhoto} 
            sx={{ width: 24, height: 24 }}
          >
            {params.row.targetName?.charAt(0) || 'U'}
          </Avatar>
          <Box>
            <Typography variant="body2" fontWeight={500}>
              {params.row.targetName}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {params.row.targetPhone}
            </Typography>
          </Box>
        </Box>
      ),
    },
    {
      field: 'type',
      headerName: 'Type',
      width: 120,
      renderCell: (params) => (
        <Chip
          icon={params.row.type === 'driver' ? <DirectionsCar fontSize="small" /> : <Person fontSize="small" />}
          label={params.row.type}
          size="small"
          color={params.row.type === 'driver' ? 'primary' : 'secondary'}
          variant="outlined"
        />
      ),
    },
    {
      field: 'rating',
      headerName: 'Rating',
      width: 160,
      renderCell: (params) => (
        <Box>
          <Chip
            label={params.row.rating}
            color={getRatingColor(params.row.rating)}
            size="small"
            sx={{ mr: 1, fontWeight: 'bold' }}
          />
          <Typography variant="caption">{getRatingStars(params.row.rating)}</Typography>
        </Box>
      ),
    },
    {
      field: 'review',
      headerName: 'Review',
      width: 350,
      renderCell: (params) => (
        <Tooltip title={params.row.review}>
          <Typography variant="body2" noWrap sx={{ maxWidth: 330 }}>
            {params.row.review}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'feedbackTags',
      headerName: 'Tags',
      width: 200,
      renderCell: (params) => (
        <Stack direction="row" spacing={0.5} flexWrap="wrap">
          {params.row.feedbackTags?.map((tag, idx) => (
            <Chip
              key={idx}
              label={tag}
              size="small"
              variant="outlined"
              sx={{ fontSize: '0.7rem' }}
            />
          ))}
        </Stack>
      ),
    },
    {
      field: 'createdAt',
      headerName: 'Date',
      width: 180,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2">
            {new Date(params.row.createdAt).toLocaleDateString()}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {new Date(params.row.createdAt).toLocaleTimeString()}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'flagged',
      headerName: 'Status',
      width: 100,
      renderCell: (params) => (
        params.row.flagged ? (
          <Chip label="Flagged" size="small" color="error" />
        ) : (
          <Chip label="Clean" size="small" color="success" />
        )
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <Tooltip title="Flag this rating">
          <IconButton 
            size="small" 
            color="error" 
            onClick={() => handleFlag(params.row.id)}
            disabled={params.row.flagged}
          >
            <Flag fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const renderDriverStats = () => {
    if (!driverStats) return null;

    const getTrendIcon = () => {
      if (driverStats.trend > 0.1) return <TrendingUp sx={{ color: '#4caf50' }} />;
      if (driverStats.trend < -0.1) return <TrendingDown sx={{ color: '#f44336' }} />;
      return null;
    };

    return (
      <StyledCard sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <Box display="flex" alignItems="center" gap={2}>
                <Avatar 
                  src={ratings.find(r => r.targetName === driverStats.driverName)?.targetPhoto}
                  sx={{ width: 60, height: 60 }}
                >
                  {driverStats.driverName?.charAt(0) || 'D'}
                </Avatar>
                <Box>
                  <Typography variant="h6" fontWeight="bold">
                    {driverStats.driverName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {driverStats.totalRatings} ratings received
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Average Rating
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h4" fontWeight="bold">
                    {driverStats.avgRating.toFixed(1)}
                  </Typography>
                  <Box display="flex" alignItems="center">
                    {getTrendIcon()}
                    <Typography variant="caption" color="text.secondary">
                      {driverStats.trend > 0.1 ? '+' : ''}{driverStats.trend.toFixed(2)}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  {getRatingStars(Math.round(driverStats.avgRating))}
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Rating Distribution
              </Typography>
              {[5, 4, 3, 2, 1].map(star => (
                <Box key={star} display="flex" alignItems="center" gap={1} mb={0.5}>
                  <Typography variant="caption" sx={{ minWidth: 20 }}>
                    {star}★
                  </Typography>
                  <LinearProgress
                    variant="determinate"
                    value={driverStats.ratingPercentages[star] || 0}
                    sx={{ 
                      flex: 1, 
                      height: 8, 
                      borderRadius: 4,
                      backgroundColor: '#e0e0e0',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: star >= 4 ? '#4caf50' : star >= 3 ? '#ff9800' : '#f44336',
                        borderRadius: 4,
                      },
                    }}
                  />
                  <Typography variant="caption" sx={{ minWidth: 40 }}>
                    {driverStats.ratingDistribution[star] || 0}
                  </Typography>
                </Box>
              ))}
            </Grid>
          </Grid>

          {driverStats.recentRatings.length > 0 && (
            <Box mt={3}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Recent Ratings
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {driverStats.recentRatings.map((rating, idx) => (
                  <Chip
                    key={idx}
                    label={`${getRatingStars(rating.rating)} ${rating.reviewerName}`}
                    size="small"
                    color={getRatingColor(rating.rating)}
                    variant="outlined"
                    icon={<RateReview fontSize="small" />}
                  />
                ))}
              </Stack>
            </Box>
          )}
        </CardContent>
      </StyledCard>
    );
  };

  if (loading && ratings.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      {/* Header */}
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Ratings & Reviews
          </Typography>
          <Typography variant="body2" color="text.secondary">
            View and manage passenger and driver ratings
          </Typography>
        </Box>
        <Button
          variant="outlined"
          startIcon={<Refresh />}
          onClick={fetchRatings}
          disabled={loading}
        >
          Refresh
        </Button>
      </Box>

      {error && (
        <Alert 
          severity="error" 
          sx={{ mb: 3 }} 
          action={
            <Button color="inherit" size="small" onClick={fetchRatings}>
              Retry
            </Button>
          }
        >
          {error}
        </Alert>
      )}

      {ratings.length === 0 && !error ? (
        <Alert severity="info" sx={{ mb: 3 }}>
          No ratings found. Ratings will appear here once available.
        </Alert>
      ) : (
        <>
          {/* Driver Selection */}
          <StyledCard sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Select Driver to View Statistics
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Select Driver</InputLabel>
                    <Select
                      value={selectedDriver || ''}
                      onChange={(e) => handleDriverSelect(e.target.value)}
                      label="Select Driver"
                    >
                      <MenuItem value="">
                        <em>All Drivers</em>
                      </MenuItem>
                      {uniqueDrivers.map((driver) => (
                        <MenuItem key={driver} value={driver}>
                          {driver}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" color="text.secondary">
                    {ratings.length} total ratings • {uniqueDrivers.length} drivers
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>

          {selectedDriver && renderDriverStats()}

          {/* Filters */}
          <StyledCard sx={{ mb: 3 }}>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  <FilterList sx={{ mr: 1, verticalAlign: 'middle' }} />
                  Filters
                </Typography>
                <Button
                  size="small"
                  onClick={clearFilters}
                  startIcon={<Clear />}
                >
                  Clear All
                </Button>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Search"
                    placeholder="Search all fields..."
                    value={filters.search}
                    onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    size="small"
                    label="CRN"
                    placeholder="Search CRN..."
                    value={filters.crn}
                    onChange={(e) => setFilters(prev => ({ ...prev, crn: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Rated By"
                    placeholder="Reviewer name..."
                    value={filters.ratedBy}
                    onChange={(e) => setFilters(prev => ({ ...prev, ratedBy: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Rated To"
                    placeholder="Target name..."
                    value={filters.ratedTo}
                    onChange={(e) => setFilters(prev => ({ ...prev, ratedTo: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Type</InputLabel>
                    <Select
                      value={filters.type}
                      onChange={(e) => setFilters(prev => ({ ...prev, type: e.target.value }))}
                      label="Type"
                    >
                      <MenuItem value="">All</MenuItem>
                      <MenuItem value="driver">Driver</MenuItem>
                      <MenuItem value="passenger">Passenger</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Rating</InputLabel>
                    <Select
                      value={filters.rating}
                      onChange={(e) => setFilters(prev => ({ ...prev, rating: e.target.value }))}
                      label="Rating"
                    >
                      <MenuItem value="">All</MenuItem>
                      {[5,4,3,2,1].map(rating => (
                        <MenuItem key={rating} value={rating}>
                          {rating} ★
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Review Contains"
                    placeholder="Search reviews..."
                    value={filters.review}
                    onChange={(e) => setFilters(prev => ({ ...prev, review: e.target.value }))}
                  />
                </Grid>
              </Grid>

              <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="caption" color="text.secondary">
                  Showing {filteredRatings.length} of {ratings.length} ratings
                </Typography>
                <Button
                  size="small"
                  startIcon={<Download />}
                  onClick={() => {
                    const headers = ['CRN', 'Rated By', 'Rated To', 'Type', 'Rating', 'Review', 'Date'];
                    const csv = [
                      headers.join(','),
                      ...filteredRatings.map(r => 
                        [r.crn, r.reviewerName, r.targetName, r.type, r.rating, `"${r.review}"`, new Date(r.createdAt).toLocaleDateString()].join(',')
                      )
                    ].join('\n');
                    const blob = new Blob([csv], { type: 'text/csv' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `ratings_${new Date().toISOString().split('T')[0]}.csv`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                  }}
                >
                  Export CSV
                </Button>
              </Box>
            </CardContent>
          </StyledCard>

          {/* Ratings Table */}
          <StyledCard>
            <CardContent>
              <DataGrid
                rows={filteredRatings}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50, 100]}
                disableSelectionOnClick
                autoHeight
                loading={loading}
                sx={{
                  '& .MuiDataGrid-cell:focus': {
                    outline: 'none',
                  },
                  '& .MuiDataGrid-row:hover': {
                    backgroundColor: 'rgba(0,0,0,0.02)',
                  },
                }}
              />
            </CardContent>
          </StyledCard>
        </>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default RatingsPage;